module.exports = __webpack_public_path__ + "static/images/styles/images/buildings/trophy-brigade-lvl2-100.78b96aaf.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/buildings/trophy-brigade-lvl2-100.png
// module id = 3582
// module chunks = 11